// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"411":"31381ef0","453":"54292a4b","512":"9ab0625b","886":"3a312e57"}[chunkId] + ".chunk.js";
};